import React from "react";

const Albuns: React.FC = () => {
  return (
    <div>
        <h1>Em manutenção</h1>
        <h2>Por favor volte mais tarde</h2>
    </div>

  )
}
export default Albuns;
